import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=142741ae&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=142741ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142741ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142741ae')) {
      api.createRecord('142741ae', component.options)
    } else {
      api.reload('142741ae', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=142741ae&scoped=true&", function () {
      api.rerender('142741ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N1MH9vbiKSII/JS/comp/CookieBox.vue"
export default component.exports